import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { History } from 'history';
import { CPAY_CHECKOUT_REDIRECT_URL } from '../../utils/constants';
import { assign } from '../../utils/browser';
import Modal from '../Modal/Modal';
import { Button } from '../Button/Button';
import { routes } from '../../utils/routerHelper';
import styles from './CheckoutRedirect.module.less';

type RedirectedModalProps = {
  id: string;
};

const RedirectedModal = ({ id }: RedirectedModalProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Modal
      width={400}
      visible
      className={styles.modal}
      footer={[
        <Button
          key="back"
          onClick={() => {
            history.push(routes.profile);
          }}
          data-testid="buttonCancelRedirectModal"
        >
          {t('modal.redirected.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => assign(`${CPAY_CHECKOUT_REDIRECT_URL}/?invoiceId=${id}`)}
          data-testid="buttonSubmitModal"
        >
          {t('modal.redirected.proceedButton')}
        </Button>
      ]}
    >
      <Typography.Text>{t('modal.redirected.proceedQuestion')}</Typography.Text>
    </Modal>
  );
};

type CheckoutRedirectProps = {
  history: History;
};

const CheckoutRedirect = ({ history }: CheckoutRedirectProps) => {
  const { id } = useParams<{ id: string }>();
  const { action: historyAction } = history;
  if (historyAction === 'PUSH') {
    return assign(`${CPAY_CHECKOUT_REDIRECT_URL}/?invoiceId=${id}`);
  }
  return <RedirectedModal id={id} />;
};

export default CheckoutRedirect;
